import { render, staticRenderFns } from "./AddGoodsImageModal.vue?vue&type=template&id=04616826&scoped=true"
import script from "./AddGoodsImageModal.vue?vue&type=script&lang=js"
export * from "./AddGoodsImageModal.vue?vue&type=script&lang=js"
import style0 from "./AddGoodsImageModal.vue?vue&type=style&index=0&id=04616826&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04616826",
  null
  
)

export default component.exports